import React, { useState } from "react";
import { connect } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import {
  Typography,
  makeStyles,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import { hideInfoDialog } from "../../store/actions/common";
import { setCookie } from "../../utils/cookies";

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: "1310 !important"
  },
  title: {
    fontSize: "1.125rem",
    lineHeight: "1․25rem",
    fontWeight: 500,
    color: "#202124"
  },
  mainText: {
    letterSpacing: "0.1px"
  },
  customActions: {
    flex: "0 0 auto",
    display: "flex",
    padding: theme.spacing(1.5, 2, 1.5, 3),
    alignItems: "center",
    justifyContent: "flex-end",
    "& button": {
      marginLeft: theme.spacing(1)
    },
    "&> :first-child": {
      background: "#EEF3FE"
    }
  },
  btn: {
    padding: theme.spacing(1.25, 2),
    letterSpacing: "0.1px",
    lineHeight: "1rem"
  },
  okBtn: {
    padding: theme.spacing(1.25, 3)
  },
  checkBox: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0),
    "& .MuiButtonBase-root": {
      padding: theme.spacing(0)
    }
  },
  checkboxLabel: {
    marginLeft: theme.spacing(1.5),
    fontSize: "0.9375rem"
  },
  containedBtn:{
    //Used important for overriding action styles!
    background: `${theme.palette.primary.main} !important`,
    color: 'white',
    "&:hover": {
      background: theme.palette.primary.main,
      color: "white",
      opacity: "0.90"
    }
  }
}));

/**
 * Basic dialog component to show message to user, cofigures using redux state with `setInfoDialogState()` action
 * @param {object} infoDialog dialog state(gotten from redux)
 * @param {object} hideInfoDialog dialog close function(also from redux)
 */
function InfoDialog({ infoDialog, hideInfoDialog }) {
  const classes = useStyles();

  const [checked, setChecked] = useState(false);

  const {
    visible,
    title,
    type,
    body,
    button,
    checkBox,
    action,
    mainButtonText = "OK",
    mainButtonVariant = ""
  } = infoDialog;

  return (
    <Dialog
      maxWidth="xs"
      open={!!visible}
      classes={{ root: classes.root }}
      onClose={() => hideInfoDialog(type)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box className={classes.title} px={3} pt={3} pb={2}>
        {title}
      </Box>

      <Box pb={1.5} px={3}>
        <Typography variant="body2" className={classes.mainText}>
          {body}
        </Typography>
      </Box>

      {checkBox && (
        <Box px={3} pt={0.5}>
          <FormControlLabel
            className={classes.checkBox}
            control={
              <Checkbox
                checked={checked}
                onChange={e => setChecked(e.target.checked)}
                name="dontShowAgain"
                color="primary"
              />
            }
            classes={{ label: classes.checkboxLabel }}
            label="Don't show again"
          />
        </Box>
      )}

      <Box className={classes.customActions}>
        {button && (
          <Button
            to={button.link}
            onClick={() => {
              hideInfoDialog("incompleteAccount");
            }}
            className={classes.btn}
            component={RouterLink}
            color="primary"
          >
            {button.text}
          </Button>
        )}
        <Button
          className={clsx(classes.btn, {
            [classes.okBtn]: mainButtonText?.length === 2,
            [classes.containedBtn]: mainButtonVariant === "contained"
          })}
          onClick={() => {
            if (!checkBox) {
              hideInfoDialog(type);
            } else {
              if (checked) {
                setCookie("dontShowLockDialog", true, 365);
              }
              hideInfoDialog(type);
              action();
            }
          }}
          color="primary"
        >
          {mainButtonText}
        </Button>
      </Box>
    </Dialog>
  );
}

const mapStateToProps = state => ({
  infoDialog: state.common.infoDialog
});

export default connect(mapStateToProps, { hideInfoDialog })(InfoDialog);
